import TimezoneSelect from "react-timezone-select";
import { useEffect, useState } from "react";

const TimeZoneDropdown = ({
  onChange = () => {},
  defaultValue,
  disabled = true,
}) => {
  const [selectedTimezone, setSelectedTimezone] = useState(defaultValue);

  useEffect(() => {
    setSelectedTimezone(defaultValue);
  }, [defaultValue]);

  const onSlectTimezone = (timeZoneData) => {
    setSelectedTimezone(timeZoneData);
    onChange("timeZone", timeZoneData.value);
  };
  return (
    <div style={{ width: "340px" }}>
      <TimezoneSelect
        value={selectedTimezone}
        onChange={onSlectTimezone}
        labelStyle={"abbrev"}
      />
    </div>
  );
};

export default TimeZoneDropdown;
